module.exports = __webpack_public_path__ + "img/error.e25708dd.png";